import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, DestroyRef, inject, Inject, OnInit, PLATFORM_ID, signal, input, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ObjFilter } from '@app/components/tools/ObjFilter';
import { Customer } from '@app/models/customers/Customer';
import { OffersFilters } from '@app/models/filtermodels/OffersFilters';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { OffersResponse } from '@app/models/offers/OffersResponse';
import { Partner } from '@app/models/partner/IPartner';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { AuthService } from '@app/services/auth.service';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { TrafficsService } from '@app/services/traffics.service';
@Component({
    selector: 'clever-hotelextrafilter',
    templateUrl: './hotelfilter.component.html',
    styleUrls: ['./hotelfilter.component.scss'],
    standalone: false
})
export class HotelExtrafFilterComponent implements OnInit {
    readonly mode = input<string>(undefined);
    readonly type = input<string>(undefined);
    readonly closeModal = output<any>();
    filtersStaticData: OffersFilters;
    tmp_filtersStaticData: OffersFilters;
    isBrowser = signal<boolean>(false);
    flexfromtraffics: string = '0';
    media: string = 'lg';
    realparams: ParamFilters;
    tourOperatorList: any;
    partner: Partner;
    destroyRef = inject(DestroyRef);
    tmp_stat: OffersResponse;
    currentCustomer: Customer;

    constructor(
        protected mediaObserver: BreakpointObserver,
        protected cdr: ChangeDetectorRef,
        protected trafficsService: TrafficsService,
        protected guardService: AuthGuardService,
        protected authService: AuthService,
        protected hotelService: HotelFiltersService,
        @Inject(PLATFORM_ID) protected platformId: any,
    ) {
        this.isBrowser.set(isPlatformBrowser(this.platformId));
    }

    ngOnInit(): void {
        if (this.isBrowser()) {
            this.initMedia();
            this.initPartnerSub();
            this.initAuth();
        }
    }

    async initAuth() {
        this.authService.auth$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((customer: Customer) => {
            if (customer?.email?.length > 0) {
                this.currentCustomer = customer;
                this.cdr.detectChanges();
            }
        });
    }

    initPartnerSub(): void {
        this.guardService.getPartner$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(partner => {
            if (partner?.partnerid?.length > 0) {
                this.partner = partner;
                this.cdr.detectChanges();
                this.initFilters();
            }
        });
    }

    initFilters(): void {
        this.hotelService.getfilters$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(params => {
            if (params && JSON.stringify(params) !== JSON.stringify(this.realparams)) {
                this.realparams = JSON.parse(JSON.stringify(params));
                this.initFilter();
            }
        });
    }

    initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.media = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.media = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.media = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.media = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.media = 'xl';
        }
    }

    closeextras() {
        this.closeModal.emit(true);
    }

    async resetAll() {
        this.hotelService.resetAllExtrasHome();
    }

    initFilter(): void {
        // console.log(JSON.parse(JSON.stringify(this.partner.agenturen)))
        this.filtersStaticData = new ObjFilter(this.realparams, 1000, this.partner.agenturen).initExtraFilters();
        this.getStaticData();
    }

    getStaticData() {
        let target = 'offers';
        // console.log(this.mode)
        switch (this.mode()) {
            case 'topregions':
                target = 'regions';
                break;
            case 'hotels':
                target = 'hotels';
                break;

            default:
                target = 'offers';
                break;
        }
        if (JSON.stringify(this.filtersStaticData) !== JSON.stringify(this.tmp_filtersStaticData)) {
            this.tmp_filtersStaticData = JSON.parse(JSON.stringify(this.filtersStaticData));
            if (target === 'offers') {
                this.filtersStaticData.optionLists = 'flightCarrier,hotelChain,roomType,boardType,roomId,arrivalAirport,departureAirport,tourOperator,inclusiveCode,transferType';
            }
            // console.log(this.filtersStaticData)
            this.trafficsService.request(this.filtersStaticData, target).pipe(
                takeUntilDestroyed(this.destroyRef)
            ).subscribe(obj => {
                this.tmp_stat = obj;
                // let found = false
                // for (let i = 0; i < obj?.inclusiveCodeList?.length; i++) {
                //     if (
                //         obj.inclusiveCodeList[i].code === 'CS' ||
                //         obj.inclusiveCodeList[i].code === 'FS' ||
                //         obj.inclusiveCodeList[i].code === 'CR'
                //     ) {
                //         found = true;
                //         i = obj.inclusiveCodeList.length;
                //     }
                // }
                // this.flexfromtraffics = found ? '0' : '1';
                this.tourOperatorList = obj?.tourOperatorList;
                this.cdr.detectChanges();
            });
        }
    }
}
